export const pageSizes = [50, 100, 200, 500];
export const defaultPageSize = pageSizes[0];
